import { ref } from 'vue';

export default function useEditorLinks({ editor, disabled }) {
  const link_url = ref(null);
  const link_menu_is_active = ref(false);
  const selected_text = ref('');

  function setLink() {
    if (disabled.value) return;
    if (!editor.value) return;

    if (link_menu_is_active.value) {
      cancelLink();
      return;
    }

    const previous_url = editor.value.getAttributes('link').href;
    const { from, to } = editor.value.state.selection;
    selected_text.value = editor.value.state.doc.textBetween(from, to, ' ');
    link_url.value = previous_url || '';
    link_menu_is_active.value = true;
  }

  function confirmLink(url) {
    if (!editor.value) return;

    const url_trimmed = (url || '').trim();

    if (!url_trimmed) {
      editor.value.chain().focus().extendMarkRange('link').unsetLink().run();
      closeLinkMenu();
      return;
    }

    const pattern = /^((http|https):\/\/)/i;
    const url_formatted = pattern.test(url_trimmed) ? url_trimmed : `http://${url_trimmed}`;

    editor.value.chain().focus().extendMarkRange('link').setLink({ href: url_formatted }).run();
    closeLinkMenu();
  }

  function cancelLink() {
    closeLinkMenu();
  }

  function closeLinkMenu({ focusEditor = true } = {}) {
    link_menu_is_active.value = false;
    link_url.value = null;

    if (focusEditor && editor.value && !disabled.value) {
      editor.value.commands.focus();
    }
  }

  return {
    link_url,
    link_menu_is_active,
    selected_text,
    setLink,
    confirmLink,
    cancelLink,
    closeLinkMenu,
  };
}
